// extracted by mini-css-extract-plugin
module.exports = {"chat":"GigAssChat_chat__PxeBL","active":"GigAssChat_active__lTpap","messages":"GigAssChat_messages__H8t0l"};